module.exports = __webpack_public_path__ + "static/media/ic_x.1528fc04.svg";